import {
  Component,
  Input,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { ContainerTransportation } from 'src/app/core/models/container-transportation';
import { ContainerTransportationService } from 'src/app/core/services/general/container-transportation.service';

@Component({
  selector: 'app-container-transportation-input',
  templateUrl: './container-transportation-input.component.html',
  styleUrls: ['./container-transportation-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: ContainerTransportationInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: ContainerTransportationInputComponent,
    },
  ],
})
export class ContainerTransportationInputComponent {
  @Input()
  title = "Select Container Transportation...";

  @Input()
  isDisabled = false;

  public value?: string;
  public localValue?: CustomSelectOption;

  public containerTransportationsList: Array<CustomSelectOption> = [];

  constructor(
    private containerTransportationService: ContainerTransportationService,
  ) {
    this.containerTransportationService
      .all()
      .subscribe((res: Array<ContainerTransportation>) => {
        this.containerTransportationsList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.writeValue(this.value);
      });
  }

  ngOnInit(): void {
  }

  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.containerTransportationsList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
